import { useContext } from "react"
import { AppMainContext } from "../context/AppMainContext";
import { useNavigate } from "react-router-dom";


export default function MyTasks_topSection() {
    const {currentUser, dateTime, handleLogout} = useContext(AppMainContext);
    const nav = useNavigate();
    return (
        <div className="myTasks_topSection">
            <div>
                <p className="myTasks_userName">{currentUser.name}</p>
                <button className="myTasks_exitBtn" onClick={()=>{handleLogout(nav)}}>יציאה</button>
            </div>
            <h1 className="myTasks_mainLogo">prodActive</h1>
            <h3 className="myTasks_time">{dateTime}</h3>
        </div>
    )
}
